import * as React from 'react';
import { SVGProps } from 'react';

const IconAllDoneSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m8.037 11.094-1.38 1.38 5.657 6.156L22.92 7.525l-1.414-1.414-9.192 9.689-4.277-4.706zM1 12.475l1.414-1.414.042.041 5.611 6.051-1.41 1.477L1 12.475z" />
    <path d="m12.215 12.81 5.049-5.285-1.415-1.414-5.109 5.109 1.475 1.59z" />
  </svg>
);
export default IconAllDoneSizeM;
